import { useTranslation } from "react-i18next";

import { noop } from "lodash";
import Dialog from "@/components/Dialog/Dialog";
import { DialogWidth } from "@/components/Dialog/types/enums";
import { useMediaQueries } from "@/shared";
import DialogActions from "@/shared/components/buttons/DialogActions";

import BottomHowCreditsWorkDialogContent from "./components/BottomHowCreditsWorkDialogContent";
import MiddleHowCreditsWorkDialogContent from "./components/MiddleHowCreditsWorkDialogContent";
import TopDialogContent from "./components/TopDialogContent/TopDialogContent";

interface HowCreditsWorkDialogProps {
  open: boolean;
  onClose: () => void;
}

const HowCreditsWorkDialog = ({ open, onClose }: HowCreditsWorkDialogProps) => {
  const { t } = useTranslation();
  const { toMd } = useMediaQueries();

  return (
    <Dialog
      open={open}
      close={onClose}
      title={t("Dashboard##how credits work##main title")}
      description={t(`Dashboard##how credits work##main description`)}
      submit={noop}
      isTitleSeparator
      isActionsSeparator
      actions={
        <DialogActions
          onClose={onClose}
          cancelButtonText={t("Button##close")}
          isLoading={false}
          isreadyToConfirm
          hideAcceptButton
        />
      }
      extendToMaxWidth={toMd}
      width={toMd ? undefined : DialogWidth.MaxWidth}
      customChildrenStyle={{ display: "grid", gap: "24px" }}
    >
      <TopDialogContent />
      <MiddleHowCreditsWorkDialogContent />
      <BottomHowCreditsWorkDialogContent />
    </Dialog>
  );
};

export default HowCreditsWorkDialog;
